/**
 * interact.js v1.3.0-alpha.4+sha.7970416-dirty
 *
 * Copyright (c) 2012-2017 Taye Adeyemi <dev@taye.me>
 * Open source under the MIT License.
 * https://raw.github.com/taye/interact.js/master/LICENSE
 */
